'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MILISECONDS = {
  IN_A_SECOND: 1000,
  IN_A_MINUTE: 60000,
  IN_AN_HOUR: 3600000,
  IN_A_DAY: 86400000,
  IN_A_WEEK: 604800000,
  IN_A_MONTH: 2628000000,
  IN_A_YEAR: 31536000000
};

var selectUnit = exports.selectUnit = function selectUnit(from) {
  var now = Date.now();
  var ms = now - from;

  switch (true) {
    case MILISECONDS.IN_A_SECOND < ms && ms < MILISECONDS.IN_A_MINUTE:
      return {
        value: -1 * Math.floor(ms / MILISECONDS.IN_A_SECOND),
        unit: 'second',
        updateIntervalInSeconds: 1
      };

    case MILISECONDS.IN_A_MINUTE < ms && ms < MILISECONDS.IN_AN_HOUR:
      return {
        value: -1 * Math.floor(ms / MILISECONDS.IN_A_MINUTE),
        unit: 'minute'
      };

    case MILISECONDS.IN_AN_HOUR < ms && ms < MILISECONDS.IN_A_DAY:
      return {
        value: -1 * Math.floor(ms / MILISECONDS.IN_AN_HOUR),
        unit: 'hour'
      };

    case MILISECONDS.IN_A_DAY < ms && ms < MILISECONDS.IN_A_WEEK:
      return {
        value: -1 * Math.floor(ms / MILISECONDS.IN_A_DAY),
        unit: 'day'
      };

    case MILISECONDS.IN_A_WEEK < ms && ms < MILISECONDS.IN_A_MONTH:
      return {
        value: -1 * Math.floor(ms / MILISECONDS.IN_A_WEEK),
        unit: 'week'
      };

    case MILISECONDS.IN_A_MONTH < ms && ms < MILISECONDS.IN_A_YEAR:
      return {
        value: -1 * Math.floor(ms / MILISECONDS.IN_A_MONTH),
        unit: 'month'
      };

    case MILISECONDS.IN_A_YEAR < ms:
      return {
        value: -1 * Math.floor(ms / MILISECONDS.IN_A_YEAR),
        unit: 'year'
      };

    default:
      return {
        value: 0
      };
  }
};